import * as firebase from 'firebase/app';
import "firebase/auth";
import 'firebase/firestore';
import 'firebase/storage';


let config: any = {
    apiKey: "AIzaSyB3I1Ald5dwgWcDdy1b4q_JquEy4Dbov7o",
    authDomain: "nursee-local.firebaseapp.com",
    databaseURL: "https://nursee-local.firebaseio.com",
    projectId: "nursee-local",
    storageBucket: "nursee-local.firebasestorage.app",
    messagingSenderId: "750493262938",
    appId: "1:750493262938:web:c7f04e92965a0855d2a463"
};

if (process.env.REACT_APP_ENV == 'staging') {

}
else if (process.env.NODE_ENV == 'production') {
        config = {
            apiKey: "AIzaSyBMGOEjlXLCDR8KEwj6cFBZc9ks-2vwR68",
            authDomain: "homis-nursee-prod.firebaseapp.com",
            databaseURL: "https://homis-nursee-prod.firebaseio.com",
            projectId: "homis-nursee-prod",
            storageBucket: "homis-nursee-prod.appspot.com",
            messagingSenderId: "1024693169396",
            appId: "1:1024693169396:web:bed849587a41152da782a1",
            measurementId: "G-JDJLK7SEK5"
  };
}

export default class Firebase {
    private static _instance: Firebase;

    public readonly app: firebase.app.App;
    public readonly store: firebase.firestore.Firestore;
    public readonly storage: firebase.storage.Storage;
    public readonly auth: firebase.auth.Auth;
    public readonly providerGoogle = new firebase.auth.GoogleAuthProvider();

    private constructor() {
        this.app = firebase.initializeApp(config);
        this.store = this.app.firestore();
        this.auth = this.app.auth();
        this.storage = this.app.storage()
    }

    public static get instance(): Firebase {
        if (!this._instance) {
            this._instance = new Firebase();
        }
        return this._instance;
    }
}
